var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"py-3",attrs:{"id":"license"}},[_c('custom-section',{attrs:{"source":"License/FAQ"}}),_c('custom-section',{attrs:{"source":"License/Legal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }